import React from "react";
import { Autocomplete, FormControl, TextField } from "@mui/material";
import { Controller, UseFormSetValue, UseFormTrigger } from "react-hook-form";

interface AutocompleteSelectProps {
  fieldName: string;
  label: string;
  fullWidth?: boolean;
  control: any;
  error?: boolean;
  helperText?: any;
  defaultValue?: string | null;
  options: any[];
  variant?: "filled" | "outlined" | "standard";
  valueKey: string;
  labelKey: string;
  disabled?: boolean;
  setValue: UseFormSetValue<any>;
  value?: string;
  trigger: UseFormTrigger<any>;
  onBlur?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onChange?: (event: React.SyntheticEvent, newValue: any) => void;
  loading?: boolean;
}

const AutocompleteSelect: React.FC<AutocompleteSelectProps> = ({
  fieldName,
  control,
  label,
  error,
  helperText,
  fullWidth,
  defaultValue,
  options,
  variant,
  valueKey,
  labelKey,
  disabled,
  value,
  setValue,
  trigger,
  onBlur,
  onChange,
  loading,
}) => {
  return (
    <FormControl fullWidth={fullWidth || true}>
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue || ""}
        render={({ field }) => (
          <Autocomplete
            {...field}
            options={options || []}
            getOptionLabel={(option: any) => option[labelKey]}
            getOptionKey={(option: any) => option[valueKey]}
            value={
              options.find(
                (o) => value === o[valueKey] || value === String(o[valueKey])
              ) || null
            }
            onChange={(event, selectedOption) => {
              setValue(fieldName, selectedOption?.[valueKey] || null);
              trigger(fieldName);
              onChange && onChange(event, selectedOption);
            }}
            loading={loading}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                error={error}
                helperText={helperText}
                onBlur={(
                  event: React.ChangeEvent<
                    HTMLInputElement | HTMLTextAreaElement
                  >
                ) => {
                  field.onBlur();
                  onBlur && onBlur(event);
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    backgroundColor: "#f2f4fb",
                    height: 38,
                  },
                  "& .MuiInputLabel-formControl": {
                    top: "-9px",
                  },
                  "& fieldset": {
                    borderColor: "#ebebec",
                  },
                }}
              />
            )}
          />
        )}
      />
    </FormControl>
  );
};

export default AutocompleteSelect;
